import { c as _c } from "react/compiler-runtime";
import { toGroupedMap } from '@newfront-insurance/core';
import type { RouterQueryOutput } from '@newfront-insurance/data-layer-server';
import { useMemo } from 'react';
import type { SharedRouter } from '../../../bff';
type Account = RouterQueryOutput<SharedRouter, 'accounts.getManyPublicAccounts'>[number];
export function useShouldShowProgramTypeByAccount(accounts) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== accounts) {
    const byBusiness = toGroupedMap(accounts, _temp);
    t1 = new Map(accounts.map(t2 => {
      const {
        uuid,
        businessUuid: businessUuid_0
      } = t2;
      const accountsInBusiness = byBusiness.get(businessUuid_0) ?? [];
      return [uuid, accountsInBusiness.length > 1];
    }));
    $[0] = accounts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const map = t0;
  let t2;
  if ($[2] !== map) {
    t2 = function shouldShowProgramType(uuid_0) {
      return map.get(uuid_0) ?? false;
    };
    $[2] = map;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(t0) {
  const {
    businessUuid
  } = t0;
  return businessUuid;
}